import { Subscription } from '@/constants/enum';
import { getAllUniqueQuotaValues } from '../../config';
import { IPricingPlanData } from '@/types/dashboard';

export const getValidQuotaValuesBySubscription = (allPlans: IPricingPlanData[], subscription: Subscription) => {
  const validQuotaValues = getAllUniqueQuotaValues(allPlans);
  return subscription === Subscription.Annually ? validQuotaValues.map((item) => item * 12) : validQuotaValues;
};

export const closestAllowedValue = (value: number, validQuotaValues: number[]) => {
  return validQuotaValues.reduce((prev, curr) => (Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev));
};
